$(document).ready(function(){
  
  $('.brands-slider').each(function(){
    
    var num_slides = 3;
    
    if(window.innerWidth >= 750){
      var num_slides = $(this).data('slides');
    }
    
    $(this).slick({
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow:3, 
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: true,
      responsive: [
        {
            breakpoint: 480, // mobile breakpoint
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    });
    
    
  });
  
});